import { converterConstants } from "./converter.constants";

export function converter(state = {}, action) {
    switch (action.type) {
        case converterConstants.TOGGLE_CONVERT_PAYROLL_MODAL:
            return {
                ...state,
                uploadPayrollModal: !state.uploadPayrollModal,
                downloadlink: null,
                imported: false,
                errorMessage: null,
                successMessage: null,
                importLoading: false,
            };
        case converterConstants.TOGGLE_PAYROLL_DOWNLOAD_LINK_MODAL:
            return {
                ...state,
                downloadLinkModal: !state.downloadLinkModal,
            };
        case converterConstants.UPLOAD_PAYROLL_FILE_REQUEST:
            return {
                ...state,
                downloadlink: null,
                importLoading: true,
                errorMessage: null,
                imported: false,
                successMessage: null,
            };
        case converterConstants.UPLOAD_PAYROLL_FILE_SUCCESS:
            return {
                ...state,
                importLoading: false,
                imported: true,
                exportDownloadId: action.result.externalUUID,
                downloadLinkModal: true,
            };
        case converterConstants.UPLOAD_PAYROLL_FILE_FAILURE:
            return {
                ...state,
                importLoading: false,
                imported: false,
                errorMessage: action.errorMessage,
            };

        case converterConstants.TOGGLE_QR_CODE_MONKEY_IMPORT_MODAL:
            return {
                ...state,
                uploadQRCodeMonkeyModal: !state.uploadQRCodeMonkeyModal,
                imported: false,
                errorMessage: null,
                successMessage: null,
                importLoading: false,
            };

        case converterConstants.UPLOAD_QR_CODE_MONKEY_IMPORT_FILE_REQUEST:
            return {
                ...state,
                importLoading: true,
                errorMessage: null,
                imported: false,
                successMessage: null,
            };

        case converterConstants.UPLOAD_QR_CODE_MONKEY_IMPORT_FILE_SUCCESS:
            return {
                ...state,
                importLoading: false,
                imported: true,
                successMessage: "Der Import wurde erfolgreich durchgeführt",
            };

        case converterConstants.UPLOAD_QR_CODE_MONKEY_IMPORT_FILE_FAILURE:
            return {
                ...state,
                importLoading: false,
                errorMessage: action.errorMessage,
                imported: false,
            };
            default:
                return state;
        }
}
